import { render, staticRenderFns } from "./CustomerCreateDashComponent.vue?vue&type=template&id=58f8ac68&scoped=true"
import script from "./CustomerCreateDashComponent.vue?vue&type=script&lang=js"
export * from "./CustomerCreateDashComponent.vue?vue&type=script&lang=js"
import style0 from "./CustomerCreateDashComponent.vue?vue&type=style&index=0&id=58f8ac68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f8ac68",
  null
  
)

export default component.exports